import { UpsellGateway } from './upsell-gateway.interface';

const baseUrl = 'gk/configurations/upsells';
export class HttpUpsellGateway implements UpsellGateway {
  getUpsellById(args: { upsellId: string }) {
    return { url: `${baseUrl}/${args.upsellId}`, method: 'GET' };
  }

  deleteUpsell(args: { upsellId: string }) {
    return { url: `${baseUrl}/${args.upsellId}`, method: 'DELETE' };
  }

  refuseUpsell(args: { upsellId: string; reason?: string; }) {
    return { url: `${baseUrl}/${args.upsellId}`, method: 'DELETE', params: { reason: args.reason, sendMail: true } };
  }

  getUpsellByProject(args: { projectId: string }) {
    return {
      url: `${baseUrl}/project/${args.projectId}`,
      method: 'GET',
    };
  }

  getUpsellByConfiguration(args: { configId: string }) {
    return {
      url: `${baseUrl}/configuration/${args.configId}`,
      method: 'GET',
    };
  }

  getUpsellByToken(args: { token: string }) {
    return { url: `${baseUrl}/token/${args.token}`, method: 'GET' };
  }

  sendUpsellSignatureLink(args: { upsellId: string }) {
    return {
      url: `${baseUrl}/${args.upsellId}/send-signature-link`,
      method: 'POST',
    };
  }

  patchUpsell(args: { upsellId: string; upsell: any }) {
    return {
      url: `${baseUrl}/${args.upsellId}`,
      method: 'PATCH',
      data: args.upsell,
    };
  }

  patchSignatureUpsell(args: { upsellId: string; data: any }) {
    return {
      url: `${baseUrl}/${args.upsellId}/signature`,
      method: 'PATCH',
      data: args.data,
    };
  }

  // getTempAmendmentFile(projectId: string, editableConfig: any) {
  //   return {
  //     url: `${baseUrl}/get-temp-amendement-file`,
  //     method: 'POST',
  //     data: { editableConfig },
  //     headers: {
  //       responseType: 'blob',
  //     },
  //   };
  // }

  getResultOfApplyUpsell(args: { upsellId: string }) {
    return {
      url: `${baseUrl}/${args.upsellId}/get-bdc-after-avenant`,
      method: 'GET',
    };
  }

  getArchiveUpsells(args: {
    month: any;
    year: any;
    searchDate: any;
    groupName: string;
  }) {
    return {
      url: `${baseUrl}/archives`,
      method: 'GET',
      params: {
        month: args.month,
        year: args.year,
        searchDate: args.searchDate,
        groupName: args.groupName,
      },
    };
  }

  getArchiveUpsellsCount(args: { year: any; searchDate: any }) {
    return {
      url: `${baseUrl}/archives/count`,
      method: 'GET',
      params: { year: args.year, searchDate: args.searchDate },
    };
  }

  postConfigurationsUpsell(args: {
    projectId: string;
    configurations: any[];
  }) {
    return {
      url: `${baseUrl}/${args.projectId}`,
      method: 'POST',
      data: { configurations: args.configurations },
    };
  }
}
